import { evalExpression } from 'ng-formly/src/core/utils';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { EntityrecordApi } from '../../sdk/services/custom';
import { LoopBackFilter } from '../../sdk/models/';
import * as _ from 'lodash';
import { PlatformApp } from '../../services/app.service';
import { CacheService } from 'ng2-cache/ng2-cache';

/*
This custom field is used to select records for an app.
*/

@Component({
    selector: 'formly-entityrecord-selector',
    template: `
   <ng-select *ngIf="items.length > 0"   
              (data)="value"  
             [active]="selectedvalues"
              (data)="refreshValue($event)"
              (selected)="selected($event)"
              (removed)="removed($event)" 
              [items]="items"
              [multiple] = "true"
              [disabled]="to.disabled"
              placeholder="" >
  </ng-select>
  `, styleUrls: ['./ng2select.scss'],
    providers: [EntityrecordApi]
})
export class EntityRecordSelectMultiple extends FieldType implements OnInit, OnDestroy {
    _loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
    items: any = [];
    selectedvalues: any = [];
    subscriptions: any = [];
    parentFieldValue = null;
    formulae = [];
    modelValues = [];


    constructor(private _EntityrecordApi: EntityrecordApi, private _cacheService: CacheService) {
        super();
    }

    ngOnInit() {
        if (!this.form['subscriptions'])
            this.form['subscriptions'] = [];

        // Adding new Controls to hold formControls for hidden fields
        if (!this.form['newcontrols'])
            this.form['newcontrols'] = {};
        for (var key in this.form.controls) {
            this.form['newcontrols'][key] = this.form.controls[key];
        }

        if (this.field['formulae']) {
            this.formulae = this.field['formulae'];
            if (this.field.formControl) {
                this.addWatcher(this.field.formControl);
            }
        }

        this.items = [];
        if (this.field['parentEntityFieldName']) {
            if (this.form['newcontrols'][this.field['parentEntityFieldName']]) {
                if (!this.form.controls[this.field['parentEntityFieldName']]) {
                    this.form.addControl(this.field['parentEntityFieldName'], this.form['newcontrols'][this.field['parentEntityFieldName']]);
                } else {
                    this.form.setControl(this.field['parentEntityFieldName'], this.form['newcontrols'][this.field['parentEntityFieldName']]);
                }
            }

            if (this.form.controls[this.field['parentEntityFieldName']]) {
                this.form['subscriptions'].push(this.form.controls[this.field['parentEntityFieldName']].valueChanges.subscribe((updatedValue: any) => {
                    if (updatedValue) {
                        delete this.model[this.key];
                        delete this.model[this.key + '_object'];
                        this.items = [];
                        //Get the field from the CacheService
                        var fields = this._cacheService.get('formfields');
                        var field = _.find(fields, { 'key': updatedValue });
                        if (field['lookupfield']) {
                            let expProp = field['expressionProperties'];
                            if (expProp && (expProp.hasOwnProperty('lookupfield') || expProp.hasOwnProperty('lookupfieldname'))) {
                                if (expProp.hasOwnProperty('lookupfield')) {
                                    this.field['lookupfield'] = evalExpression(expProp['lookupfield'].expression, this, [this.model, this.options.fromState]);
                                }
                                if (expProp.hasOwnProperty('lookupfieldname')) {
                                    this.field['lookupfieldname'] = evalExpression(expProp['lookupfieldname'].expression, this, [this.model, this.options.fromState]);
                                }
                            } else {
                                this.field['lookupfield'] = field['lookupfield'];
                                this.field['lookupfieldname'] = field['lookupfieldname'];
                            }
                            this.setLookupValues();
                        }
                    }
                }));
            }
        }

        // Setting data element filter
        if (this.field['cascaded'] && this.field['parentFieldName']) {
            if (this.form['newcontrols'][this.field['parentFieldName']]) {
                if (!this.form.controls[this.field['parentFieldName']]) {
                    this.form.addControl(this.field['parentFieldName'], this.form['newcontrols'][this.field['parentFieldName']]);
                } else {
                    this.form.setControl(this.field['parentFieldName'], this.form['newcontrols'][this.field['parentFieldName']]);
                }
            }

            if (this.form.controls[this.field['parentFieldName']]) {
                this.form['subscriptions'].push(this.form.controls[this.field['parentFieldName']].valueChanges.subscribe((updatedValue: any) => {
                    if (updatedValue) {
                        this.parentFieldValue = updatedValue;
                        this.selectedvalues = [];
                        this.setLookupValues();
                    }
                }));
                if (this.model[this.field['parentFieldName']]) {
                    this.form.controls[this.field['parentFieldName']].setValue(this.model[this.field['parentFieldName']]);
                }
            }
        } else {
            if (this.field['lookupfield'])
                this.setLookupValues();
            else
                this.field.formControl.disable();
        }
    }

    setLookupValues() {

        let expProp = this.field['expressionProperties'];
        if (expProp && (expProp.hasOwnProperty('lookupfield') || expProp.hasOwnProperty('lookupfieldname'))) {
            if (expProp.hasOwnProperty('lookupfield')) {
                this.field['lookupfield'] = evalExpression(expProp['lookupfield'].expression, this, [this.model, this.options.fromState]);
            }
            if (expProp.hasOwnProperty('lookupfieldname')) {
                this.field['lookupfieldname'] = evalExpression(expProp['lookupfieldname'].expression, this, [this.model, this.options.fromState]);
            }
        }
        this.items = [];
        this._loopbackfilter.where = {};
        this._loopbackfilter.where['appId'] = this.model.appId;
        this._loopbackfilter.where['entityId'] = this.field['lookupfield'];
        if (this.field['cascaded'] && this.field['parentFieldLookupName']) {
            if (Array.isArray(this.parentFieldValue)) {
                this._loopbackfilter.where['data.' + this.field['parentFieldLookupName']] = { inq: this.parentFieldValue };
            } else {
                this._loopbackfilter.where['data.' + this.field['parentFieldLookupName']] = this.parentFieldValue;
            }
        }

        //Get the records for the App
        this.form['subscriptions'].push(this._EntityrecordApi.find(this._loopbackfilter).subscribe((records) => {
            if (records) {
                this.items = [];
                this.selectedvalues = [];
                for (var i = 0; i < records.length; i++) {
                    if (this.model[this.key] && this.model[this.key].indexOf(records[i]['id']) > -1)
                        this.selectedvalues.push({ id: records[i]['id'], text: "" + records[i]['data'][this.field['lookupfieldname']] });
                    else
                        this.items.push({ id: records[i]['id'], text: "" + records[i]['data'][this.field['lookupfieldname']] });
                }
                this.items = _.sortBy(this.items, 'text');
            }
        }));
    }

    addWatcher(formControl) {
        this.form['subscriptions'].push(formControl.valueChanges.subscribe((updatedValue: any) => {
            for (var i = 0; i < this.formulae.length; i++) {
                var formula = this.formulae[i];
                if (this.setModelValues(formula['fields'], updatedValue)) {
                    this.setResults(formula['results'], PlatformApp.processData(formula['formula'], this.modelValues));
                }
            }
        }));
    }

    setModelValues(fieldArray, updatedValue) {
        var requiredFieldsExist = true;
        this.modelValues = [];
        for (var j = 0; j < fieldArray.length; j++) {
            if (!this.model[fieldArray[j]]) {
                requiredFieldsExist = false;
                break;
            } else {
                if (fieldArray[j] == this.field.key) {
                    this.modelValues.push(updatedValue);
                } else {
                    this.modelValues.push(this.model[fieldArray[j]]);
                }
            }
        }
        return requiredFieldsExist;
    }

    setResults(resultArray, value): void {
        for (var i = 0; i < resultArray.length; i++) {
            var resultField = resultArray[i];
            if (this.form.controls[resultField]) {
                this.form.controls[resultField].setValue(value);

                if (this.form['newcontrols'][resultField] && !this.model[resultField]) {
                    this.form.setControl(resultField, this.form['newcontrols'][resultField]);
                    this.form.controls[resultField].setValue(value);
                }
            } else {
                if (this.form['newcontrols'][resultField]) {
                    this.form.addControl(resultField, this.form['newcontrols'][resultField]);
                    this.form.controls[resultField].setValue(value);
                } else {
                    this.model[resultField] = value;
                }
            }
        }
    }

    ngOnDestroy() {
        this.selectedvalues = [];
        this.items = [];
        for (var i = 0; i < this.subscriptions.length; i++) {
            this.subscriptions[i].unsubscribe();
        }
    }


    public selected(value: any): void {
        /*
        Push the selected value to the model
        */
        if (this.model[this.key] && this.model[this.key].length) {
            this.model[this.key].push(value.id);
        } else {
            this.model[this.key] = [value.id];
        }
    }

    public removed(value: any): void {
        /*
       Remove the removed value to the model
       */
        if (this.model[this.key] && this.model[this.key].length) {
            this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
        }
    }

    public typed(): void {

    }

    public refreshValue(value: any): void {
    }

}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/selectentityrecord-multiple.ts